function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".sell_mobile_svg__st0{fill:#e6e6e6}.sell_mobile_svg__st1{fill:#3f3d56}.sell_mobile_svg__st2{fill:#3367d6}.sell_mobile_svg__st3{fill:#fff}");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "sell_mobile_svg__st0",
  d: "M70.4 122.4c6.3 0 11.3-8.4 11.3-18.7 0-10.3-5.1-18.7-11.3-18.7-6.3 0-11.4 8.4-11.4 18.7 0 10.4 5.1 18.7 11.4 18.7z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "sell_mobile_svg__st1",
  d: "M71.4 134.4c-4.5-22.1 0-44.1 0-44.3l.9.1c0 .2-4.5 22.1 0 44l-.9.2z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "sell_mobile_svg__st1",
  d: "M80.3 99.7l-10.2 4.4.4.6 10.2-4.4-.4-.6zM59.7 101.9l-.4.6 10.2 4.4.4-.6-10.2-4.4zM298.7 1.3h-18.6v52.1h18.6V1.3z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "sell_mobile_svg__st1",
  d: "M311 43.5L265.8 0l-90.6.7-55 43.4 1.1.6h-.3V135h189.8V44.7l.2-1.2z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "sell_mobile_svg__st2",
  d: "M265.9.1l-56.4 53.6V135h101.3V43.5L265.9.1z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "sell_mobile_svg__st1",
  d: "M270.9 90h-20.7v14.8h20.7V90zM270.9 64.3h-20.7v14.6h20.7V64.3z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "sell_mobile_svg__st3",
  d: "M270.9 90h-20.7v14.8h20.7V90zM270.9 64.3h-20.7v14.6h20.7V64.3z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "sell_mobile_svg__st0",
  d: "M195.4 132.3s.4-7.5 9.5-6.7l-9.5 6.7z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "sell_mobile_svg__st2",
  d: "M192.9 125.1c2.5 0 4.6-1.7 4.6-3.7s-2-3.7-4.6-3.7c-2.5 0-4.6 1.7-4.6 3.7 0 2.1 2 3.7 4.6 3.7z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "sell_mobile_svg__st0",
  d: "M193.4 127.7h-1.3v7.3h1.3v-7.3z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "sell_mobile_svg__st2",
  d: "M43.2 111.5c12.2 0 22.1-16.4 22.1-36.6s-9.9-36.6-22.1-36.6S21 54.6 21 74.8s9.9 36.7 22.2 36.7z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "sell_mobile_svg__st1",
  d: "M45.6 134.7c-8.9-43.1-.1-86 0-86.5l.9.1c-.1.4-8.8 43.3 0 86.2l-.9.2z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "sell_mobile_svg__st1",
  d: "M62.9 67.2l-20 8.7.4.6 20-8.7-.4-.6zM22.1 71.6l-.4.6 20 8.7.4-.6-20-8.7z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "sell_mobile_svg__st2",
  d: "M95.6 102.9c16.7 0 30.3-22.5 30.3-50.1S112.3 2.6 95.6 2.6c-16.7 0-30.3 22.5-30.3 50.1s13.6 50.2 30.3 50.2z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "sell_mobile_svg__st1",
  d: "M99.1 134.7C87 75.8 99 17 99.1 16.5l.9.1c-.1.6-12.1 59.2 0 118l-.9.1z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "sell_mobile_svg__st1",
  d: "M122.6 42.5L95.2 54.4l.4.6L123 43.1l-.4-.6zM66.7 48.5l-.4.6L93.7 61l.4-.6-27.4-11.9zM327 134.4H0v.6h327v-.6zM178.9 86.1h-20.7v14.8h20.7V86.1zM178.9 60.4h-20.7V75h20.7V60.4z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "sell_mobile_svg__st3",
  d: "M178.9 86.1h-20.7v14.8h20.7V86.1zM178.9 60.4h-20.7V75h20.7V60.4z"
});

function SvgSellMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sell_mobile_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 327 135",
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
}

export default SvgSellMobile;